import empty from './empty';

const prop = (k, ...ks) => x => empty(x) || empty(k)
  ? x
  : prop(...ks)(x[k]);

export default prop;
